import React, { useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Label } from '../../components/ui/label';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Textarea } from '../../components/ui/textarea';
import { DollarSign } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Invoices
export const ClientInvoices = ({ token, invoices }) => (
  <Card>
    <CardHeader><CardTitle>Mis Facturas ({invoices.length})</CardTitle><CardDescription>Facturas generadas por el servicio</CardDescription></CardHeader>
    <CardContent>
      <div className="space-y-2">
        {invoices.map(invoice => (
          <div key={invoice.id} className="border p-4 rounded-lg">
            <div className="flex justify-between items-start mb-3">
              <div>
                <p className="font-semibold text-lg">${invoice.total.toFixed(2)}</p>
                <p className="text-sm text-gray-600">Factura: {invoice.invoice_number}</p>
                <p className="text-xs text-gray-400 mt-1">Creado: {new Date(invoice.created_at).toLocaleDateString()}</p>
              </div>
              <span className={`px-3 py-1 rounded-full text-xs font-semibold ${invoice.status === 'pending' ? 'bg-yellow-100 text-yellow-800' : invoice.status === 'paid' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                {invoice.status === 'pending' ? 'Pendiente' : invoice.status === 'paid' ? 'Pagado' : 'Cancelado'}
              </span>
            </div>
            <Button size="sm" variant="outline" onClick={async () => {
              try {
                const response = await axios.get(`${API}/client/invoices/${invoice.id}/pdf`, { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a'); link.href = url; link.setAttribute('download', `FACTURA_${invoice.invoice_number}.pdf`);
                document.body.appendChild(link); link.click(); link.remove();
              } catch (error) { alert('Error al descargar PDF'); }
            }} className="w-full">Descargar Factura PDF</Button>
          </div>
        ))}
        {invoices.length === 0 && <div className="text-center py-12"><DollarSign className="mx-auto h-12 w-12 text-gray-400" /><p className="text-gray-500">No tienes facturas</p></div>}
      </div>
    </CardContent>
  </Card>
);

// Notify Payment
export const ClientNotifyPayment = ({ token, paymentForm, setPaymentForm, onSubmit }) => (
  <>
    <Card className="bg-blue-50 border-blue-200">
      <CardHeader><CardTitle className="text-blue-900">Informacion para Realizar Pagos</CardTitle><CardDescription>Utiliza cualquiera de estos metodos para pagar tus facturas</CardDescription></CardHeader>
      <CardContent className="space-y-4">
        <div className="grid md:grid-cols-2 gap-4">
          <div className="bg-white p-4 rounded-lg border border-blue-200"><h4 className="font-bold text-blue-900 mb-2">ZELLE</h4><p className="text-sm"><span className="font-semibold">Email:</span> colantuonia3@gmail.com</p><p className="text-sm"><span className="font-semibold">Nombre:</span> Antonio Colantuoni</p></div>
          <div className="bg-white p-4 rounded-lg border border-blue-200"><h4 className="font-bold text-blue-900 mb-2">PAYPAL</h4><p className="text-sm"><span className="font-semibold">Email:</span> roger94rd@gmail.com</p><p className="text-sm"><span className="font-semibold">Nombre:</span> Roger Parra</p><p className="text-sm text-red-600 font-semibold">Monto + 9% comision</p></div>
          <div className="bg-white p-4 rounded-lg border border-blue-200"><h4 className="font-bold text-blue-900 mb-2">BINANCE</h4><p className="text-sm"><span className="font-semibold">Email:</span> roger94rd@gmail.com</p><p className="text-sm"><span className="font-semibold">Nombre:</span> Roger Parra</p></div>
          <div className="bg-white p-4 rounded-lg border border-blue-200"><h4 className="font-bold text-blue-900 mb-2">ZINLI</h4><p className="text-sm"><span className="font-semibold">Email:</span> roger94rd@gmail.com</p><p className="text-sm"><span className="font-semibold">Nombre:</span> Roger Parra</p></div>
        </div>
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mt-4"><p className="text-sm text-yellow-800"><strong>IMPORTANTE:</strong> Despues de realizar el pago, completa el formulario de abajo con los detalles de tu transaccion y adjunta el comprobante.</p></div>
      </CardContent>
    </Card>
    <Card>
      <CardHeader><CardTitle>Notificar Pago</CardTitle><CardDescription>Informa sobre un pago realizado y adjunta el comprobante</CardDescription></CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2"><Label>Nombre del Pagador *</Label><Input value={paymentForm.payer_name} onChange={(e) => setPaymentForm({...paymentForm, payer_name: e.target.value})} placeholder="Nombre completo de quien realizo el pago" required /></div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2"><Label>Monto ($) *</Label><Input type="number" step="0.01" value={paymentForm.amount} onChange={(e) => setPaymentForm({...paymentForm, amount: e.target.value})} placeholder="0.00" required /></div>
            <div className="space-y-2"><Label>Fecha de Pago *</Label><Input type="date" value={paymentForm.payment_date} onChange={(e) => setPaymentForm({...paymentForm, payment_date: e.target.value})} required /></div>
          </div>
          <div className="space-y-2"><Label>Metodo de Pago *</Label><Select value={paymentForm.payment_method} onValueChange={(value) => setPaymentForm({...paymentForm, payment_method: value})} required><SelectTrigger><SelectValue placeholder="Seleccionar metodo" /></SelectTrigger><SelectContent><SelectItem value="zelle">Zelle</SelectItem><SelectItem value="paypal">PayPal (+9% comision)</SelectItem><SelectItem value="binance">Binance</SelectItem><SelectItem value="zinli">Zinli</SelectItem></SelectContent></Select></div>
          <div className="space-y-2"><Label>Numero de Referencia / Codigo de Confirmacion *</Label><Input value={paymentForm.reference_number} onChange={(e) => setPaymentForm({...paymentForm, reference_number: e.target.value})} placeholder="Codigo de transaccion o referencia" required /></div>
          <div className="space-y-2">
            <Label>Comprobante de Pago (PDF, JPG, PNG)</Label>
            <Input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={(e) => setPaymentForm({...paymentForm, receipt_file: e.target.files[0]})} className="cursor-pointer" />
            {paymentForm.receipt_file && <p className="text-xs text-green-600">Archivo seleccionado: {paymentForm.receipt_file.name}</p>}
          </div>
          <div className="space-y-2"><Label>Notas adicionales (opcional)</Label><Textarea value={paymentForm.notes} onChange={(e) => setPaymentForm({...paymentForm, notes: e.target.value})} placeholder="Informacion adicional sobre el pago" rows={3} /></div>
          <div className="bg-yellow-50 border border-yellow-200 p-3 rounded"><p className="text-sm text-yellow-800"><strong>Importante:</strong> Asegurate de incluir el numero de factura en las notas y adjuntar el comprobante de pago.</p></div>
          <Button type="submit">Notificar Pago</Button>
        </form>
      </CardContent>
    </Card>
  </>
);

// My Payments
export const ClientMyPayments = ({ payments }) => (
  <Card>
    <CardHeader><CardTitle>Mis Pagos ({payments.length})</CardTitle><CardDescription>Historial de pagos notificados</CardDescription></CardHeader>
    <CardContent>
      <div className="space-y-3">
        {payments.map(payment => (
          <div key={payment.id} className={`border-2 p-4 rounded-lg ${payment.status === 'pending' ? 'border-yellow-300 bg-yellow-50' : payment.status === 'verified' ? 'border-green-300 bg-green-50' : 'border-red-300 bg-red-50'}`}>
            <div className="flex justify-between items-start mb-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <p className="font-bold text-2xl text-gray-800">${payment.amount.toFixed(2)}</p>
                  <span className={`px-3 py-1 rounded-full text-xs font-bold ${payment.status === 'pending' ? 'bg-yellow-200 text-yellow-900' : payment.status === 'verified' ? 'bg-green-200 text-green-900' : 'bg-red-200 text-red-900'}`}>
                    {payment.status === 'pending' ? 'EN REVISION' : payment.status === 'verified' ? 'APROBADO' : 'RECHAZADO'}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div><p className="text-gray-600">Metodo de Pago</p><p className="font-semibold">{payment.payment_method}</p></div>
                  <div><p className="text-gray-600">Referencia</p><p className="font-semibold">{payment.reference_number}</p></div>
                  <div><p className="text-gray-600">Fecha de Pago</p><p className="font-semibold">{new Date(payment.payment_date).toLocaleDateString()}</p></div>
                  <div><p className="text-gray-600">Fecha de Notificacion</p><p className="font-semibold">{new Date(payment.created_at).toLocaleDateString()}</p></div>
                </div>
                {payment.notes && <div className="mt-3 p-2 bg-white rounded border"><p className="text-xs text-gray-600"><strong>Notas:</strong> {payment.notes}</p></div>}
                {payment.status === 'verified' && payment.verified_at && <div className="mt-2 text-xs text-green-700">Verificado el {new Date(payment.verified_at).toLocaleString()}</div>}
              </div>
            </div>
          </div>
        ))}
        {payments.length === 0 && <div className="text-center py-12"><p className="text-gray-500">No has notificado pagos</p></div>}
      </div>
    </CardContent>
  </Card>
);

// Accounts
export const ClientAccounts = ({ accounts }) => (
  <Card>
    <CardHeader><CardTitle>Cuentas Bancarias</CardTitle><CardDescription>Cuentas disponibles para realizar pagos</CardDescription></CardHeader>
    <CardContent>
      <div className="space-y-3">
        {accounts.map(account => (
          <div key={account.id} className="border p-4 rounded-lg">
            <h3 className="font-semibold">{account.account_name}</h3>
            <p className="text-sm text-gray-600">Banco: {account.bank_name}</p>
            <p className="text-sm text-gray-600">Numero: {account.account_number}</p>
            <p className="text-sm text-gray-600">Tipo: {account.account_type}</p>
            <p className="text-xs text-gray-400 mt-1">Moneda: {account.currency}</p>
          </div>
        ))}
        {accounts.length === 0 && <div className="text-center py-12"><p className="text-gray-500">No hay cuentas bancarias configuradas</p></div>}
      </div>
    </CardContent>
  </Card>
);

export default ClientInvoices;
